var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRainbowWave = function SvgRainbowWave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 704,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#RainbowWave_svg__a)",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M2672 903.999c-1452.21.253-1753.826-66.789-3206-66.536m3206 66.536c-1453 .228-1753.003-170.522-3206-170.295m3206 170.295c-1453.82.202-1752.214-274.231-3206-274.028m3206 274.028c-1454.61.177-1751.391-377.939-3206-377.787m3206 377.787c-1455.43.152-1750.602-481.673-3206-481.521m3206 481.521c-1456.22.127-1749.778-585.381-3206-585.28m3206 585.28C1214.96 904.1 923.011 214.884-534 214.985m3206 689.014c-1457.83.076-1748.166-792.823-3206-792.747m3206 792.747C1213.34 904.05 924.623 7.442-534 7.493m3206 896.506c-1459.45 0-1746.554-1000.265-3206-1000.24m3206 1000.24C1211.73 903.999 926.235-200-534-200"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "RainbowWave_svg__a",
    x1: 1069,
    x2: 1069,
    y1: -200,
    y2: 903.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25CE73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#00FFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#346AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#F13FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#F96A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#E47018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFBC5B"
  })))));
};
export default SvgRainbowWave;